import React, { useEffect, useRef, useState } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import { Button, Card, Checkbox, Col, Divider, Form, Input, InputNumber, List, Radio, Row, Select, Switch, Table } from 'antd';
import systemConfig from '../../../config/systematic';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../universal/getList';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import antMessage from '../../../utils/extend/AntdNotification'
import FaPiao from './FaPiao';
import idHandle from '../../../utilsTs/baseLib/idHandle';



/**订单预结页面 */
export default function CateringOrderPrint(props: any) {
    const { data, closeModal } = props;

    const [form] = Form.useForm(); //form 


    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;


    const [serviceChargeData, setServiceChargeData] = useState<Array<any>>([]);


    const [printModeTypeData, setPrintModeTypeData] = useState<any>();

    /**服务费率 */
    const [serviceRate, setServiceRate] = useState<number>(0);

    const [cashPrice, setCashPrice] = useState<number>(0);


    /**打印机 */
    const [printData, setPrintData] = useState<Array<any>>([])
    //帐单类型
    const [accountTypeData, setAccountTypeData] = useState<Array<any>>([]);
    //支付码数据
    const [paymentListData, setPaymentListData] = useState<Array<any>>([]);
    // const [smallCharge, setSmallCharge] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false)
    const isPayCode = Form.useWatch("isPayCode", form) as any;
    const printModeType = Form.useWatch("printModeType", form) as any;
    const shouldMoney = Form.useWatch("shouldMoney", form) as any;
    const realMoney = Form.useWatch("realMoney", form) as any;
    const smallCharge = Form.useWatch("smallCharge", form) as any;
    const eraseSpecificationId = Form.useWatch("eraseSpecificationId", form) as any;



    const notificationApi = useNotificationInstance();
    const [eraseData, setEraseData] = useState<any>();
    const [isPartialCheckout, setIsPartialCheckout] = useState<boolean>(false)
    const inputRef = useRef<any>(null);
    const [payDetails, setPayDetails] = useState<Array<any>>([])
    const [initPaymentLlists, setInitPaymentLlists] = useState<Array<any>>([]);
    const [isPayDetailsOpen, setIsPayDetailsOpen] = useState<boolean>(false);
    const [isCurrentPaymentData, setIsCurrentPaymentData] = useState<any>();
    const [seletePaymentData, setSeletePaymentData] = useState<any>([]);
    const [isCurrentPrice, setIsCurrentPrice] = useState<any>(0);
    const [deletePaymentListIds, setDeletePaymentListIds] = useState<Array<any>>([]);
    const [deletePaymentIds, setDeletePaymentIds] = useState<Array<any>>([]);

    const [isFaPiao, setIsFaPiao] = useState<boolean>(false);
    const [faPiaoOpen, setFaPiaoOpen] = useState<boolean>(false);
    const [faPiaoData, setFaPiaoData] = useState<any>();
    const payDetailsClose = () => {
        setIsPayDetailsOpen(false)
        setCashPrice(0)
    }
    const handleOk = (e: any, isFaPiao?: boolean) => {

        setLoading(true)
        form.validateFields() //数据校验
            .then(async (values: any) => {
                fetchApi.POST(wmService, {
                    apiId: "cateringOrder",
                    apiExtend: "preClosing",
                    apiData: {
                        id: data.id,
                        isIo: data.isIo,
                        ...values,
                        derateServiceCharge: parseFloat((values.derateServiceCharge).toFixed(2)),
                        serviceCharge: parseFloat((values.serviceCharge).toFixed(2)),
                        shouldServiceCharge: parseFloat((values.shouldServiceCharge).toFixed(2)),
                        smallCharge,
                        serviceRate,
                        orderPaymentModeId: data?.orderPaymentModeId,
                        isReverseClosing: data.isReverseClosing,
                        paymentMethodList: seletePaymentData,
                        isPartialCheckout,
                        deletePaymentListIds,
                        isFaPiao,
                        deletePaymentIds
                        // counts:13
                        // menuSpe:selectMenuSpeData
                    }
                }).then(res => {
                    let caOrderStatus = res.data.data.caOrderStatus;
                    let branchStoreId = res.data.data.branchStoreId

                    if (caOrderStatus === 998) {
                        setLoading(false)
                        showCustomNotification(notificationApi!, {
                            type: 'success',
                            message: "预结成功",
                            description: "success",
                            duration: 0.5
                        });
                        // antMessage('success', '预结成功', 'success', { duration: 0.5 });
                        closeModal(false);
                    } else {

                        setLoading(false)
                        showCustomNotification(notificationApi!, {
                            type: 'success',
                            message: "结账成功",
                            description: "success",
                            duration: 0.5
                        });

                        // antMessage('success', '预结成功', 'success', { duration: 0.5 });



                        if (isFaPiao) {
                            //  closeModal(false);
                            setFaPiaoData({ orderId: data.id, branchStoreId });
                            setFaPiaoOpen(true)


                        } else {
                            closeModal(true);
                        }
                    }

                }).catch(err => {
                    console.log("err", err);

                    setLoading(false)
                    showCustomNotification(notificationApi!, {
                        type: 'error',
                        message: "错误，无法保存",
                        description: err.message + ' | status：' + err.errors.status,
                    });
                    if (err.errors.status === 616) {
                        initData()


                    }
                })
            })
            .catch((err: any) => {

                console.log("err", err);
                setLoading(false)
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });;
            });


    }
    const handleCancel = (e: any) => {
        closeModal(false)

    }

    //关闭发票选择页面
    const onClosefaPiao = async (status: boolean) => {
        // setFaPiaoOpen(false)
        closeModal(true)

    }
    //初始化数据
    const initData = (apiData?: any) => {

        fetchApi.GET(wmService, {
            apiId: "cateringOrder",
            apiExtend: "showSingleEx",
            apiVariable: data.id,
            apiData: {
                orderPaymentModeId: data.orderPaymentModeId
            }

        }).then((res) => {
            setDeletePaymentListIds([])
            setDeletePaymentIds([])
            setIsPartialCheckout(res.data.branchStore.isPartialCheckout)
            setIsFaPiao(res.data.branchStore.isFaPiao)
            setPayDetails(res.data.payDetails)
            setSeletePaymentData(res.data.initPaymentLlists)
            let counts = res.data.counts
            let isTarry = res.data.isTarry;
            let isAutoPrint = res.data.branchStore.isAutoPrint;
            let isAutoPrintCateringCheckoutDetailAccountsOrder = res.data.branchStore.isAutoPrintCateringCheckoutDetailAccountsOrder;
            let isOnlinePayment = res.data.isOnlinePayment
            let totalMoney = res.data.totalMoney ? res.data.totalMoney : 0;
            let agioMoney = res.data.agioMoney ? res.data.agioMoney : 0;
            let giftPrice = res.data.giftPrice ? res.data.giftPrice : 0;
            let realMoney = res.data.realMoney ? res.data.realMoney : 0;

            let serviceRate = res.data.serviceCharge.serviceCharge;
            let countSerPrice = res.data.countSerPrice ? res.data.countSerPrice : 0;
            // let freePrice=res.data.freePrice?res.data.freePrice:0;

            //未算服务费金额
            let recePriceIng = totalMoney - agioMoney - giftPrice;

            //应收服务费
            let shouldServiceCharge = recePriceIng * Number(serviceRate);
            //实收服务费
            let serviceCharge = countSerPrice * Number(serviceRate);
            //减免服务费
            let derateServiceCharge = shouldServiceCharge - serviceCharge;
            console.log("res.data", res.data);

            form.setFieldValue("isPayCode", isOnlinePayment);


            if (isAutoPrint) {
                if (!form.getFieldValue("printerIds")) {
                    let printerIds = apiData?.printerIds ? apiData?.printerIds : []
                    form.setFieldValue("printerIds", printerIds);
                }

            }
            let eraseSpecificationId = apiData?.eraseSpecificationId ? apiData?.eraseSpecificationId : form.getFieldValue("eraseSpecificationId")

            //初始应收/实付价格(未抹零)
            let receAndRealPrice = recePriceIng + serviceCharge;

            /**抹零后的价格 */
            let smallChangePrice = receAndRealPrice;
            switch (eraseSpecificationId) {
                /**保留到元，角位无条件抹除 */
                case 1:
                    if (Number(receAndRealPrice) < 1) {
                        smallChangePrice = receAndRealPrice
                    } else {
                        smallChangePrice = Math.floor(receAndRealPrice);
                    }

                    break;
                /**不抹零 */
                case 2:
                    smallChangePrice = receAndRealPrice;
                    break;
            }
            //初始化抹零的价格
            let smallCharge = receAndRealPrice - smallChangePrice;

            form.setFieldsValue({
                serviceChargeId: res.data.serviceCharge.id,
                totalMoney,
                agioMoney,
                giftPrice,
                realMoney,
                countSerPrice,
                shouldMoney: smallChangePrice,
                derateServiceCharge,
                shouldServiceCharge,
                serviceCharge,
                smallCharge,
                isCateringCheckoutDetailAccountsOrder: isAutoPrintCateringCheckoutDetailAccountsOrder,
                roomId: res.data.roomId,
                counts,
                isTarry,
                roomTypeId: res.data.roomTypeId
                // freePrice
            })

            setServiceRate(serviceRate)
            // setSmallCharge(smallCharge)
            // initOrderPrint()
        })
    }
    useEffect(() => {
        let apiData: any = {

        }
        form.setFieldValue("isPayCode", true);
        form.setFieldValue("printModeType", 2);

        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "serviceCharge",
                apiExtend: "showList",
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                }

            }).then((res) => {
                let data = res.data;
                setServiceChargeData(data)
            })
            fetchApi.GET(wmService,
                {
                    apiId: 'generalData',
                    apiVariable: 'printOrderType',
                    apiExtend: 'showList',
                    apiData: {
                        ids: ["cateringCheckoutDetailAccountsOrder", "cateringCheckoutDeptAccountsOrder", "cateringCheckoutClassifyAccountsOrder"]
                    }
                }).then(res => {

                    if (res.success) {
                        setAccountTypeData(res.data)
                    }
                });

            fetchApi.GET(wmService,
                {
                    apiId: 'generalData',
                    apiVariable: 'printModeType',
                    apiExtend: 'showLists',

                }).then(res => {
                    const { printModeType
                    } = res.data;
                    setPrintModeTypeData(printModeType)



                });

            fetchApi.GET(wmService,
                {
                    apiId: 'printer',
                    apiExtend: 'showList',
                    apiData: {
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },
                    }

                }).then(res => {

                    if (res.success) {
                        if (res.data.length > 0) {
                            apiData.printerIds = [res.data[0].id]
                        }

                        setPrintData(res.data)

                    }
                });

            fetchApi.GET(wmService,
                {
                    apiId: 'paymentList',
                    apiExtend: 'showList',
                    apiData: {
                        // isPayCode: true,
                        // isOnlinePayment: true,
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },

                    }
                }).then(res => {

                    if (res.success) {

                        if (res.data.length > 1) {
                            let newData: Array<any> = [];
                            let payCodeList: Array<any> = [];
                            for (let i = 0; i < res.data.length; i++) {
                                if (res.data[i].isOnlinePayment && res.data[i].isPayCode) {
                                    form.setFieldValue("paymentListId", res.data[i].id)
                                    payCodeList.push({ ...res.data[i] })
                                } else {
                                    newData.push({ ...res.data[i] })
                                }
                            }

                            setInitPaymentLlists(newData)

                            setPaymentListData(payCodeList)
                        }

                    }
                });
            let eraseData = await fetchApi.GET(wmService,
                {
                    apiId: 'erase',
                    apiExtend: 'showList',
                    apiData: {
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },
                    }

                })
            if (eraseData.success) {

                setEraseData(eraseData.data)
                if (eraseData.data.length > 0) {

                    form.setFieldValue("eraseSpecificationId", eraseData.data[0].eraseSpecificationId);
                    apiData.eraseSpecificationId = eraseData.data[0].eraseSpecificationId;

                }
            }


            initData(apiData)
            // .then(res => {

            //     if (res.success) {

            //         setEraseData(res.data)
            //         if (res.data.length > 0) {
            //             console.log("什么时候执行");

            //             form.setFieldValue("eraseSpecificationId", res.data[0].eraseSpecificationId);
            //             apiData.eraseSpecificationId = res.data[0].eraseSpecificationId;

            //         }
            //     }
            // });
        }

        fetchData()

        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current?.focus()!;
            }
        }, 100)

    }, [])

    const changeServiceCharge = (a: any, b: any) => {
        let totalMoney = form.getFieldValue("totalMoney");
        let agioMoney = form.getFieldValue("agioMoney");

        let giftPrice = form.getFieldValue("giftPrice");

        let countSerPrice = form.getFieldValue("countSerPrice");

        let eraseSpecificationId = form.getFieldValue("eraseSpecificationId")

        // let freePrice = form.getFieldValue("freePrice");




        let serviceRate = b.children;
        let isDerateServiceCharge = form.getFieldValue("isDerateServiceCharge");

        //未算服务费金额
        let recePriceIng = totalMoney - agioMoney - giftPrice;

        //应收服务费
        let shouldServiceCharge = parseFloat((recePriceIng * Number(serviceRate)).toFixed(2));

        //实收服务费
        let serviceCharge = 0;
        //减免服务费

        // = countSerPrice * Number(serviceRate);

        //应收/实付价格(未抹零)(已加服务费)
        let receAndRealPrice: number = 0;
        if (isDerateServiceCharge) {
            //应收/实付价格(未抹零)(减免服务费)
            receAndRealPrice = recePriceIng;
            serviceCharge = 0
        } else {
            //实收服务费
            serviceCharge = parseFloat((countSerPrice * Number(serviceRate)).toFixed(2));
            //应收/实付价格(未抹零)(已加服务费)
            receAndRealPrice = recePriceIng + serviceCharge;
        }

        let derateServiceCharge = shouldServiceCharge - serviceCharge;
        /**抹零后的价格 */
        let smallChangePrice = 0;
        switch (eraseSpecificationId) {
            /**保留到元，角位无条件抹除 */
            case 1:
                if (Number(receAndRealPrice) < 1) {
                    smallChangePrice = receAndRealPrice
                } else {
                    smallChangePrice = Math.floor(receAndRealPrice);
                }

                break;
            /**不抹零 */
            case 2:
            case 3:

                smallChangePrice = receAndRealPrice;
                break;
        }

        //化抹零后价格
        // let smallChangePrice = Math.floor(receAndRealPrice);
        //化抹零的价格
        let smallCharge = parseFloat((receAndRealPrice - smallChangePrice).toFixed(2));

        // setSmallCharge(smallCharge);
        setServiceRate(serviceRate);

        form.setFieldsValue({
            shouldMoney: smallChangePrice,
            serviceCharge,
            smallCharge,
            shouldServiceCharge,
            derateServiceCharge
        })


    }



    /**减免服务费 */
    const isDerateServiceCharge = (e: boolean) => {
        let totalMoney = form.getFieldValue("totalMoney");
        let agioMoney = form.getFieldValue("agioMoney");
        let giftPrice = form.getFieldValue("giftPrice");
        let countSerPrice = form.getFieldValue("countSerPrice");



        //未算服务费金额
        let recePriceIng = totalMoney - agioMoney - giftPrice;
        let eraseSpecificationId = form.getFieldValue("eraseSpecificationId")


        //应收服务费
        let shouldServiceCharge = parseFloat((recePriceIng * Number(serviceRate)).toFixed(2));
        //实收服务费
        let serviceCharge = 0;

        let receAndRealPrice: number = 0;
        if (e) {
            //应收/实付价格(未抹零)(减免服务费)
            receAndRealPrice = recePriceIng;

            serviceCharge = 0
        } else {

            //实收服务费
            serviceCharge = parseFloat((countSerPrice * Number(serviceRate)).toFixed(2));
            //应收/实付价格(未抹零)(已加服务费)
            receAndRealPrice = recePriceIng + serviceCharge;
        }
        //减免服务费
        let derateServiceCharge = shouldServiceCharge - serviceCharge;
        /**抹零后的价格 */
        let smallChangePrice = receAndRealPrice;
        switch (eraseSpecificationId) {
            /**保留到元，角位无条件抹除 */
            case 1:
                if (Number(receAndRealPrice) < 1) {
                    smallChangePrice = receAndRealPrice
                } else {
                    smallChangePrice = Math.floor(receAndRealPrice);
                }

                break;
            /**不抹零 */
            case 2:
                smallChangePrice = receAndRealPrice;
                break;
        }

        //化抹零的价格
        let smallCharge = parseFloat((receAndRealPrice - smallChangePrice).toFixed(2))

        // setSmallCharge(smallCharge);
        form.setFieldsValue({
            shouldMoney: smallChangePrice,
            derateServiceCharge,
            shouldServiceCharge,
            serviceCharge,
            smallCharge
        })

    }

    const changePayCode = (e: any) => {
        if (e && paymentListData.length === 1) {
            form.setFieldValue("paymentListId", paymentListData[0].id)
        }

    }

    const onChangePrintModeType = (e: any) => {
        switch (Number(e)) {
            case 2:
                // initOrderPrint()
                break;

            default:
                form.resetFields(["printerIds"])
                break;
        }

    }
    const onChangeEraseSpecification = (e: any) => {
        let totalMoney = form.getFieldValue("totalMoney");
        let agioMoney = form.getFieldValue("agioMoney");
        let giftPrice = form.getFieldValue("giftPrice");
        let serviceCharge = form.getFieldValue("serviceCharge");

        //初始应收/实付价格(未抹零)
        let receAndRealPrice = totalMoney - agioMoney - giftPrice + serviceCharge;

        /**抹零后的价格 */
        let smallChangePrice = receAndRealPrice;
        switch (Number(e)) {
            case 1:
                if (Number(receAndRealPrice) < 1) {
                    smallChangePrice = receAndRealPrice
                } else {
                    smallChangePrice = Math.floor(receAndRealPrice);
                }
                break;
            case 2:
            case 3:
                smallChangePrice = receAndRealPrice;
                break;
        }
        //初始化抹零的价格
        let smallCharge = receAndRealPrice - smallChangePrice;

        form.setFieldsValue({
            totalMoney,
            agioMoney,
            giftPrice,
            shouldMoney: smallChangePrice,
            smallCharge,
            serviceCharge,

            // freePrice
        })
        // setSmallCharge(smallCharge)

    }

    /**选择支付方式 */
    const payDetailsChage = (e: any) => {
        let id = idHandle.getShortUuid()

        let selectData = [{ copies: 1, ...e, money: isCurrentPrice, status: 2, id, paymentMethodListId: e.id }]

        let lastSelectData = seletePaymentData.concat(selectData);

        setSeletePaymentData(lastSelectData)

        payDetailsClose()

        setCashPrice(0)


        form.setFieldValue("realMoney", (realMoney ? Number(realMoney) : 0) + Number(isCurrentPrice))

    }
    /** 修改金额*/
    const changePrice = (e: any, paymentType?: any) => {
        if (paymentType === 6) {

            if (e > (shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)) {
                setCashPrice(e)

                setIsCurrentPrice((shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0))

            } else {
                setIsCurrentPrice(e)
                setCashPrice(0)

            }
        } else {
            setIsCurrentPrice(e)

        }
    }



    /**修改抹零金额 */
    const onChangeSmallCharge = (e: any) => {
        if (e > 10) {
            antMessage("warning", '不得超过10元', "错误", { duration: 0.5 });
            return false
        }
        e = e ? e : 0
        let totalMoney = form.getFieldValue("totalMoney");
        let agioMoney = form.getFieldValue("agioMoney");
        let giftPrice = form.getFieldValue("giftPrice");
        let serviceCharge = form.getFieldValue("serviceCharge");

        let lastPirce = totalMoney - agioMoney - giftPrice + serviceCharge - e;
        form.setFieldsValue({
            shouldMoney: lastPirce,
            smallCharge: e,
        })

    }
    const payDetailCon = () => {

        switch (isCurrentPaymentData.paymentType) {
            case 1:
            case 5:

                return <InputNumber min={0.1} controls={false} defaultValue={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} max={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} onChange={(e) => changePrice(e)} addonBefore={<div>金额:</div>}></InputNumber>
            case 2:
                return <div style={{ justifyContent: "space-between", display: "flex", fontSize: 16 }}><InputNumber min={0.1} style={{ width: "50%" }} readOnly value={isCurrentPrice} onChange={(e) => changePrice(e)} addonBefore={<div>金额:</div>}></InputNumber> <InputNumber defaultValue={1} min={1} onChange={(e) => numberCopies(e, isCurrentPaymentData)} style={{ width: "50%" }} addonBefore={<>张数:</>} /></div>
            case 4:
                return <div style={{ justifyContent: "space-between", display: "flex", fontSize: 16 }}><InputNumber min={0.1} style={{ width: "50%" }} value={isCurrentPrice} onChange={(e) => changePrice(e)} addonBefore={<div>金额:</div>}></InputNumber></div>
            case 6:

                return <InputNumber min={0.1} controls={false} defaultValue={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} onChange={(e) => changePrice(e, isCurrentPaymentData.paymentType)} addonBefore={<div>金额:</div>} addonAfter={<div> {cashPrice - (isCurrentPrice) > 0 ? `应找${cashPrice - isCurrentPrice}` : ""} </div>}></InputNumber>
            default:
                return <></>
        }
    }
    const numberCopies = (e: any, isCurrentPaymentData: any) => {

        setIsCurrentPaymentData({ ...isCurrentPaymentData, copies: e })

        let price = e * isCurrentPaymentData.deductionAmount;
        changePrice(price)

    }
    return (
        <>
            <AntDraggableModal
                title={<div>预结订单{data.headCount > 0 ? "" : <span style={{ color: "red" }}>(提示:未加入茶位/人数)</span>}</div>}
                open={true}
                // okText='确定'
                // cancelText='取消'
                // onOk={handleOk}
                // onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                        确认
                    </Button>,
                    <Button style={{ display: isFaPiao ? "inline-block" : "none" }} type="primary" disabled={isFaPiao && isPartialCheckout ? (shouldMoney === realMoney ? false : true) : true} loading={loading} onClick={(e) => handleOk(e, true)}>
                        确认并开发票
                    </Button>,
                ]}
                closable={false}
                maskClosable={false}
                width={"80%"}
                confirmLoading={loading}
            >
                {/* <Row> */}
                {/* <Col span={10}> */}
                <div >
                    <Form
                        form={form}
                        name="Edit"
                        onFinish={handleOk}

                        initialValues={{
                            showDiscount: true,
                            showPerCapita: true,
                            showPeople: true,
                            showName: true,
                            printType: "cateringCheckoutDetailAccountsOrder",

                        }}
                        onKeyDown={(e: any) => {
                            if (e.key === 'Enter') {
                                handleOk(e)
                            }
                        }}
                    >
                        <Row>
                            <Col span={10}>
                                <Row>
                                    <Col span={8}>
                                        <Form.Item
                                            label="消费总额"
                                            name="totalMoney">

                                            <InputNumber ref={inputRef} readOnly autoFocus precision={2} addonAfter={"元"} ></InputNumber>
                                        </Form.Item>
                                    </Col>



                                    <Col span={8}>
                                        <Form.Item
                                            label="折扣额"
                                            name="agioMoney">
                                            <InputNumber addonBefore={<>-</>} precision={2} addonAfter={"元"} readOnly ></InputNumber>
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            label="赠送金额"
                                            name="giftPrice">
                                            <InputNumber addonBefore={<>-</>} precision={2} addonAfter={"元"} readOnly ></InputNumber>
                                        </Form.Item>
                                    </Col>
                                </Row>




                                <Col span={24} style={{ display: "none" }}>
                                    <Form.Item
                                        label="服务费金额"
                                        name="countSerPrice">
                                        <InputNumber precision={2} addonAfter={"元"} readOnly ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="服务费率"
                                        name="serviceChargeId"
                                        rules={[{ message: '请选择服务费!', required: true }]}>
                                        <Select
                                            onChange={changeServiceCharge}
                                            // showSearch
                                            placeholder="选择服务费"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(serviceChargeData, 'serviceCharge')}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="应收服务费"
                                        name="shouldServiceCharge">
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="减免服务费"
                                        name="derateServiceCharge">
                                        <InputNumber addonBefore={<>-</>} precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="实收服务费"
                                        name="serviceCharge">
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col style={{ display: "none" }} span={24}>
                                    <Form.Item
                                        label="房间id"
                                        name="roomId">
                                        <Input disabled ></Input>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label="抹零金额"
                                        name="smallCharge"
                                        rules={[
                                            { type: 'number', max: 10, message: '输入值不能超过10' },
                                        ]}
                                    >
                                        <InputNumber onChange={onChangeSmallCharge} readOnly={eraseSpecificationId === 3 ? false : true} precision={2} addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="应收金额"
                                        name="shouldMoney">
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="已收金额"
                                        name="realMoney"
                                        rules={[
                                            {
                                                validator: async (_, names) => {
                                                    let dataEx = form.getFieldsValue()
                                                    const { shouldMoney, realMoney } = dataEx;
                                                    if (realMoney > shouldMoney) return Promise.reject(new Error("应收金额应该>=实收金额,挂账金额有误，请调整"));

                                                },

                                            },
                                        ]}
                                    >
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>


                                <Col span={24}>

                                    <InputNumber addonBefore={"待收金额"} value={shouldMoney - realMoney} precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                </Col>

                                {
                                    seletePaymentData?.length > 0 ? <Col span={24}>
                                        <List
                                            size="small"
                                            dataSource={seletePaymentData}
                                            renderItem={(item: any) => <List.Item>
                                                <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                                    <div>{item.paymentMethodName}</div>
                                                    <div>￥{item.money.toFixed(2)}</div>
                                                    <div onClick={() => {

                                                        if (item.status === 1) {

                                                            let newArray: Array<string> = [...deletePaymentListIds, item.id];
                                                            let newArrayEx: Array<string> = [...deletePaymentIds, item.paymentMethodId];
                                                            setDeletePaymentIds(newArrayEx)
                                                            setDeletePaymentListIds(newArray)
                                                        }

                                                        setSeletePaymentData((prevData: any) => {

                                                            return prevData.filter((item1: any) => item1.id !== item.id)
                                                        })
                                                        form.setFieldValue("realMoney", (realMoney ? Number(realMoney) : 0) - Number(item.money))
                                                    }}>撤销</div>

                                                </div></List.Item>}
                                        />



                                    </Col> : null

                                }
                                <Row>
                                    <Col span={8}>
                                        <Form.Item
                                            label="服务费减免"
                                            name="isDerateServiceCharge"
                                            valuePropName="checked"

                                            initialValue={false}>
                                            < Switch checked={false}
                                                onChange={isDerateServiceCharge}
                                                checkedChildren="是"
                                                unCheckedChildren="否" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label="打印预结单"
                                            name="isCateringCheckoutDetailAccountsOrder"
                                            valuePropName="checked"

                                            initialValue={true}>
                                            < Switch checked={true}
                                                checkedChildren="是"
                                                unCheckedChildren="否" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            tooltip={"此功能 目前作用于,大厅订单还未结账时候，并且不能结账的情况下，不影响新客人下单的情况下，处理订单"}
                                            label="滞留"
                                            name="isTarry"
                                            valuePropName="checked"

                                            initialValue={false}>
                                            < Switch checked={false}
                                                checkedChildren="是"
                                                unCheckedChildren="否" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Form.Item
                                            label="抹零规则"
                                            name="eraseSpecificationId"
                                            rules={[{ message: '请选择抹零规则!', required: true }]}
                                        >
                                            <Select
                                                // popupMatchSelectWidth={250}
                                                // showSearch
                                                onChange={onChangeEraseSpecification}
                                                placeholder="选择抹零规格"
                                                // optionFilterProp="children"
                                                fieldNames={
                                                    { value: "eraseSpecificationId", label: "eraseSpecificationName" }
                                                }
                                                options={eraseData}
                                                filterOption={(input, option: any) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>

                                                {/* {getList.general(eraseData, 'eraseSpecificationName')} */}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label="打印模式"
                                            name="printModeType"
                                            rules={[{ message: '请选择打印模式!', required: true }]}>
                                            <Select
                                                popupMatchSelectWidth={150}
                                                // showSearch
                                                onChange={onChangePrintModeType}
                                                placeholder="选择打印模式"
                                                optionFilterProp="children"
                                                filterOption={(input, option: any) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                {getList.general(printModeTypeData, 'name')}
                                            </Select>
                                        </Form.Item>
                                    </Col>


                                    {/**帐单类型 */}
                                    <Col span={8}>
                                        <Form.Item
                                            label="帐单类型"
                                            name="printType"
                                            rules={[{ message: '请选择帐单类型!', required: true }]}>
                                            <Select

                                                // onChange={onChangePrintType}
                                                // showSearch
                                                placeholder="选择帐单类型"
                                                optionFilterProp="children"
                                                filterOption={(input, option: any) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                {getList.general(accountTypeData, 'name')}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={11}>


                                <Col span={24}>
                                    <Form.Item
                                        label="支付二维码"
                                        name="isPayCode"
                                        valuePropName="checked"

                                        initialValue={false}>
                                        < Switch checked={false}
                                            onChange={changePayCode}
                                            checkedChildren="是"
                                            unCheckedChildren="否" />
                                    </Form.Item>
                                </Col>





                                {isPayCode ? <Col span={24}>
                                    <Form.Item
                                        label=""
                                        name="paymentListId"
                                    >
                                        <Radio.Group>
                                            {paymentListData.length > 0 ?
                                                paymentListData.map((item) => {
                                                    return <Radio value={item.id}>{item.paymentMethodName}</Radio>
                                                })

                                                : null}


                                        </Radio.Group>
                                    </Form.Item>

                                </Col> : ""}

                                <Col style={{ display: "none" }} span={24}>
                                    <Form.Item
                                        label="菜品数量"
                                        name="counts">
                                        <InputNumber></InputNumber>
                                    </Form.Item>
                                </Col>


                                <Col span={24}>
                                    <Form.Item
                                        label="指定打印机"
                                        name="printerIds"
                                    >
                                        <Select
                                            disabled={printModeType === 1 ? true : false}
                                            showSearch
                                            mode="multiple"
                                            allowClear
                                            placeholder="指定打印机"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(printData, 'printerName')}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {isPartialCheckout && initPaymentLlists.length > 0 ?
                                    <div
                                        id="scrollableDiv"
                                        style={{
                                            height: 350,
                                            overflow: 'auto',
                                            padding: '0 16px',
                                            marginTop: 20,
                                            border: '1px solid rgba(140, 140, 140, 0.35)',
                                        }}
                                    >
                                        <List
                                            itemLayout="horizontal"
                                            grid={{ gutter: 16, column: 4 }}

                                            dataSource={initPaymentLlists}
                                            // position
                                            renderItem={(menu: any) => {
                                                return (
                                                    <List.Item onClick={() => {
                                                        setIsCurrentPaymentData(menu)
                                                        if (menu.paymentMethodId === "wiscaMembershipCard") {
                                                            antMessage("error", `暂时不支持${menu.paymentMethodName}`);
                                                            return false
                                                        }
                                                        if (shouldMoney !== 0) {
                                                            if (realMoney === shouldMoney) {
                                                                antMessage("error", "实付金额已跟应付金额相等");
                                                                return false
                                                            }
                                                        }

                                                        // if (seletePaymentData.length > 0) {
                                                        //     let findData = seletePaymentData.find((item: any) => item.id === menu.id);
                                                        //     if (findData) {
                                                        //         antMessage("error", "该结账方式已存在，无法重复加入");
                                                        //         return false
                                                        //     }

                                                        // }
                                                        if (menu.paymentType === 2) {
                                                            if ((Number(shouldMoney) - Number(realMoney)) < menu.deductionAmount) {
                                                                antMessage("error", "该结账方式是优惠券，剩余金额小于代金券抵扣金额，暂不可使用");
                                                                return false
                                                            }
                                                            setIsCurrentPrice(menu.deductionAmount)
                                                        } else {
                                                            setIsCurrentPrice((shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0))

                                                        }

                                                        if (menu.paymentType === 4) {
                                                            if ((Number(shouldMoney) - Number(realMoney)) < menu.deductionAmount) {
                                                                antMessage("error", "该结账方式是优惠券，剩余金额小于代金券抵扣金额，暂不可使用");
                                                                return false
                                                            }
                                                            setIsCurrentPrice(menu.deductionAmount)
                                                        }

                                                        setIsPayDetailsOpen(true)

                                                    }}>
                                                        <Card
                                                            size='small'
                                                            title={
                                                                <>
                                                                    <div style={{ justifyContent: "space-between", display: "flex", fontSize: 13 }}>
                                                                        <div >{menu.paymentMethodName}</div>
                                                                    </div>
                                                                </>
                                                            }
                                                        >

                                                        </Card>
                                                    </List.Item>
                                                )
                                            }}
                                        />
                                    </div>
                                    : null}



                            </Col>

                        </Row>
                    </Form>



                </div>
                {/* </Col> */}


                {/* </Row> */}

            </AntDraggableModal>
            {isPayDetailsOpen ? <AntDraggableModal

                open={true}
                // okButtonProps={{ disabled: true }}
                // cancelButtonProps={{ disabled: true }}
                okText='确定'
                cancelText="取消"
                onCancel={() => { payDetailsClose() }}
                onOk={() => { payDetailsChage(isCurrentPaymentData) }}
                title={`支付方式:${isCurrentPaymentData?.paymentMethodName}${isCurrentPaymentData.paymentType === 2 ? ` 抵扣金额:${isCurrentPaymentData.deductionAmount}元` : ""}`}
                width={800}>
                {payDetailCon()}
                {/* {isCurrentPaymentData.paymentType === 1 ? <InputNumber defaultValue={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} max={(shouldMoney ? Number(shouldMoney) : 0) - (realMoney ? Number(realMoney) : 0)} onChange={(e) => changePrice(e)} addonAfter={<Button onClick={(e) => payDetailsChage(isCurrentPaymentData)}>确认</Button>} addonBefore={<div>金额:</div>}></InputNumber> : null} */}
            </AntDraggableModal> : null}

            {/**发票页面 */}
            {faPiaoOpen ? (<FaPiao data={faPiaoData} closeModal={onClosefaPiao} />) : null}

        </>
    )
}
